/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cj_header_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`First row is a header`)
};

const es_cj_header_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La primera fila es un encabezado`)
};

const de_cj_header_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erste Zeile ist eine Kopfzeile`)
};

const nl_cj_header_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eerste rij is een koptekst`)
};

const fr_cj_header_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La première ligne est un en-tête`)
};

const it_cj_header_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La prima riga è un'intestazione`)
};

const pt_br2_cj_header_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primeira linha é um cabeçalho`)
};

const pt_cj_header_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A primeira linha é um cabeçalho`)
};

const ja_cj_header_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最初の行がヘッダーである`)
};

const zh_cj_header_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`第一行是表头`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cj_header_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cj_header_label(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cj_header_label", locale)
	if (locale === "en") return en_cj_header_label(inputs)
	if (locale === "es") return es_cj_header_label(inputs)
	if (locale === "de") return de_cj_header_label(inputs)
	if (locale === "nl") return nl_cj_header_label(inputs)
	if (locale === "fr") return fr_cj_header_label(inputs)
	if (locale === "it") return it_cj_header_label(inputs)
	if (locale === "pt-BR") return pt_br2_cj_header_label(inputs)
	if (locale === "pt") return pt_cj_header_label(inputs)
	if (locale === "ja") return ja_cj_header_label(inputs)
	return zh_cj_header_label(inputs)
};